import * as React from 'react'
import {formatProductsUnits} from "@ui-seeker/utils";
import {Box} from "@mui/material";


export default function totalColumn() {
    return {
        name: 'total', label: 'Total',
        options: {
			setCellProps: () => ({ sx: {
				verticalAlign: 'top'
			}}),
			customBodyRowRender: value => <Box sx={{ textAlign: 'center', pt: 1 }}>
				{formatProductsUnits(value)}
			</Box>
        }
    }
}